import { gs1_api } from "./api";
const { post } = gs1_api;

const userLogin = async (data) => {
	console.log("login in.........");

	return await post("/gs1/standard/user/login", data, {
		headers: {
			"content-type": "application/json",
		},
		withCredentials: true,
	});
};

const forgotPassword = async (email) => {
	return await post("/gs1/standard/user/forgot-password", { email });
};

const createNewPassword = async (payload) => {
	return await post("/gs1/standard/user/new-password", payload);
};

const verifyOTP = async (payload) => {
	return await post(`user/otp`, payload);
};

export { userLogin, forgotPassword, createNewPassword, verifyOTP };
